import { ChildEventProps, SALES_STATUS } from './types';

export const eventIsOnSale = (event: ChildEventProps) =>
    (event?.is_sales_ended === false && event?.is_sold_out === false) ||
    (event &&
        'sales_status' in event &&
        event?.sales_status === SALES_STATUS.ON_SALE);

export const eventIsSalesEnded = (event: ChildEventProps) =>
    (event && 'is_sales_ended' in event && event?.is_sales_ended == true) ||
    (event &&
        'sales_status' in event &&
        event?.sales_status === SALES_STATUS.SALES_ENDED);

export const eventIsSoldOut = (event: ChildEventProps) =>
    (event && 'is_sold_out' in event && event?.is_sold_out == true) ||
    (event &&
        'sales_status' in event &&
        event?.sales_status === SALES_STATUS.SOLD_OUT);

export const getSalesStatus = (event: ChildEventProps) => {
    if (event?.sales_status) {
        return event.sales_status;
    } else {
        return eventIsOnSale(event)
            ? SALES_STATUS.ON_SALE
            : SALES_STATUS.DEFAULT;
    }
};

export const getPurchasableEvents = (childEvents: ChildEventProps[] | null) => {
    return childEvents?.filter(eventIsOnSale);
};

export const findFirstPurchasableEvent = (
    childEvents: ChildEventProps[] | null,
) => {
    if (!childEvents) return null;
    const availableEvents: ChildEventProps[] =
        childEvents.filter(eventIsOnSale);
    return availableEvents[0] ?? null;
};

export const getEventChildById = (
    childEvents: ChildEventProps[] | null,
    eventId: string,
) => childEvents?.find((event) => event.id === eventId) || {};
